// extracted by css-extract-rspack-plugin
export default {"counter":"counter--Vz1o132mRgGRJrHt"};